import MainControlsContainerDesktop from '../../controls/MainControlsContainerDesktop';
import Legend from '../../map/Legend';
import OpenLayersMap from '../../map/OpenLayersMap';

const useStyles = ({ width }) => ({
  container: {
    position: 'relative',
    width: `${width}%`,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  mapContainer: {
    width: 'calc(100% - 40px)',
    height: '100%',
    margin: 20,
  },
});

const MapPanelLayoutDesktop = ({ width }) => {
  const styles = useStyles({ width });
  return (
    <div id="map-panel-container" style={styles.container}>
      <MainControlsContainerDesktop />
      <div style={styles.mapContainer}>
        <OpenLayersMap rounded />
        <Legend rounded />
      </div>
    </div>
  );
};

export default MapPanelLayoutDesktop;
